import { render, staticRenderFns } from "./OtherForms.vue?vue&type=template&id=1a1961c5"
import script from "./OtherForms.vue?vue&type=script&lang=ts"
export * from "./OtherForms.vue?vue&type=script&lang=ts"
import style0 from "./OtherForms.vue?vue&type=style&index=0&id=1a1961c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports